import React from "react";
import { Package, Shield, Truck, FileText, Globe, Clock } from "lucide-react";
import { Card, CardContent } from "../../components/ui/card";

const valueCards = [
  {
    id: 1,
    icon: "FileText",
    title: "One-Click Documentation",
    description:
      "Auto-generate commercial invoices, certificates of origin, and customs forms in any language.",
  },
  {
    id: 2,
    icon: "Shield",
    title: "Compliance Guaranteed",
    description:
      "Stay compliant with international trade regulations through automated checks and updates.",
  },
  {
    id: 3,
    icon: "Truck",
    title: "Real-Time Tracking",
    description:
      "Monitor your shipments from port to door with live updates and predictive ETAs.",
  },
  {
    id: 4,
    icon: "Globe",
    title: "Global Network",
    description:
      "Connect with verified suppliers and logistics partners across 150+ countries.",
  },
  {
    id: 5,
    icon: "Package",
    title: "Smart Inventory",
    description:
      "Optimize stock levels with AI-powered demand forecasting and automated reordering.",
  },
  {
    id: 6,
    icon: "Clock",
    title: "24/7 Support",
    description:
      "Get expert assistance whenever you need it with our dedicated trade specialists.",
  },
];

const getIcon = (iconName) => {
  const icons = { FileText, Shield, Truck, Globe, Package, Clock };
  return icons[iconName] || Package;
};

export const ValueCards = () => {
  return (
    <div id="features" className="bg-slate-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold text-slate-600 uppercase tracking-wider mb-8">
          Powering Global Trade Since 2020
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {valueCards.map((card) => {
            const Icon = getIcon(card.icon);
            return (
              <Card
                key={card.id}
                className="bg-white border-slate-200 hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer group"
              >
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-200 transition-colors">
                    <Icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    {card.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {card.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ValueCards;
